import { NgIf } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { EmrButtonComponent, EmrModalComponent } from 'emr-ng-shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class EditShipmentResponseOkEventArgs {
  modalRef: BsModalRef;
  hasError: boolean;
  closeOnOk: boolean;
}

@Component({
    selector: 'app-edit-shipment-response',
    templateUrl: './edit-shipment-response.component.html',
    styleUrls: ['./edit-shipment-response.component.css'],
    standalone: true,
    imports: [EmrModalComponent, EmrButtonComponent, NgIf]
  })

  export class EditShipmentResponseComponent {
    @Output() ok = new EventEmitter<EditShipmentResponseOkEventArgs>();

    hasError = false;
    errorMessage: string = null;
    closeOnOk: boolean;
    debugErrorMessage = null;

    // Begin - Missing bound variabels
    showCloseButton: boolean;
    // End - Missing bound variables
    constructor(public bsModalRef: BsModalRef) {}

    onOkClick() {
      const args = new EditShipmentResponseOkEventArgs();
      args.modalRef = this.bsModalRef;
      args.hasError = this.hasError;
      args.closeOnOk = this.closeOnOk;

      this.ok.emit(args);

      this.bsModalRef.hide();
    }
  }
